import {Injectable} from '@angular/core';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';

import {Thesis} from 'shared/classes/thesis';
import {ThesisOverviewRepository} from '../repositories/thesis-overview.repository';
import { TranslatedText } from 'shared/models/translated-text';

@Injectable()
export class ThesisOverviewService {

  constructor(private thesisOverviewRepository: ThesisOverviewRepository) { }

  public getTheses(): Observable<Array<Thesis>> {
    return this.thesisOverviewRepository.getTheses()
      .map((theses: Array<Thesis>) => {
        return theses.map((thesis: Thesis) => {
          thesis.languageCount = {
            de: this.getLanguageCount(thesis, 'de'),
            en: this.getLanguageCount(thesis, 'en'),
          };

          return thesis;
        });
      });
  }

  public deleteThesis(id: string): Observable<Response> {
    return this.thesisOverviewRepository.deleteThesis(id);
  }

  private getLanguageCount(thesis: Thesis, language: string): Number {
    return thesis.text.filter((text: TranslatedText) => {
      return text[language] !== null &&
             text[language] !== undefined &&
             text[language].length > 0;
    }).length;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/thesis/thesis-overview/services/thesis-overview.service.ts